import React from "react";
import Synonyms from "./Synonyms.js";

export default function Meaning(props) {
  return (
    <div className="section">
      <h3>{props.meaning.partOfSpeech}</h3>
      <p> {props.meaning.definition}</p>
      <p>
        <Synonyms data={props.meaning.synonyms} />
      </p>
      <p className="example">{props.meaning.example}</p>
    </div>
  );
}
